<template>
  <div class="page-locate">

    <div class="container slick-wrapper" data-aos="fade-in" data-aos-once="true" v-if="false">
      <slick ref="slick" :options="slickOptions">
        <div v-for="image in images" v-bind:key="image.title" :caption="image.title" :href="image.src" :src="image.src"><img v-if="isDesktop" :src="image.src" /><img v-else :src="image.srcMobile" /></div>
        <!-- </lightbox> -->
      </slick>
    </div>

    <div class="container container-tabs" v-if="locations && locations.length > 0" data-aos="fade-in" data-aos-once="true">
      <div class="tabs">
        <ul>
          <li v-for="(location, index) in locations" :class="{ 'is-active': selectedLocation === index }"><a @click="selectedLocation = index"><span class="is-smallscreen">{{ location.shortname }}</span><span class="is-hidden-smallscreen">{{ location.location.place }}</span></a></li>
          <!-- <span class="is-hidden">, {{ location.location.area }}</span> -->
        </ul>
      </div>
      <div class="content">
        <h1 class="title">{{ locations[selectedLocation] ? locations[selectedLocation].name : 'invalid' }}</h1>
      </div>
    </div>

    <div class="container container-map map" v-if="locations && locations[selectedLocation] && !locations[selectedLocation].removed && locations.length > 0" data-aos="fade-in" data-aos-once="true">
      <div class="search" v-if="false">
        <gmap-autocomplete
          :value="locations[selectedLocation].location.location"
          @place_changed="setPlace"
          placeholder="Enter location" />
      </div>
      <div class="placecard__container" style="z-index:2;">
        <div class="placecard__left">
          <p class="placecard__business-name">{{ locations[selectedLocation].name }}</p>
          <p class="placecard__info">{{ locations[selectedLocation].location.location }}</p>
          <a class="placecard__view-large" :href="locations[selectedLocation].location.link" target="_blank" id="A_41">View larger map</a>
         </div>
        <div class="placecard__right">
          <a class="placecard__direction-link" :href="locations[selectedLocation].location.direction" target="_blank" id="A_9">
            <div class="placecard__direction-icon"></div>
            Directions
          </a>
        </div>
      </div>
      <gmap-map
        class="gmap"
        :center="locations[selectedLocation].position"
        :options="{ styles: mapStyle, /* disableDefaultUI: true, */ scrollwheel: false, navigationControl: true, mapTypeControl: false, scaleControl: true, zoomControl: true, streetViewControl: false, rotateControl: true, fullscreenControl: true }"
        :zoom="locations[selectedLocation].zoom"><!-- map-type-id="terrain" -->
        <gmap-marker
          :position="locations[selectedLocation].position"
          :icon="mapIcon"
          :place="selectedPlace">
        </gmap-marker>
      </gmap-map>
      <gmap-street-view-panorama
        class="pano"
        :position="locations[selectedLocation].position"
        :pov="{ heading: 0, pitch: 10 }"
        :zoom="1"
        v-if="false" />
    </div>

    <div class="container container-content" v-if="locations && locations[selectedLocation] && !locations[selectedLocation].removed && locations.length > 0" style="margin-top:1rem;" data-aos="fade-up" data-aos-once="true">
      <div class="columns">
        <div class="column is-3 container-apps">
          <div class="waze" style="display:inline;">
            <a :href="wazeUrl" target="_blank"><img src="../assets/waze.svg" width="60" class="img-responsive" data-pin-nopin="true" style="border:1px solid lightgray;border-radius:20px;padding:8px;background-color:white;"></a>
          </div>
          <div class="google-map" style="display:inline;">
            <a :href="googleMapsUrl" target="_blank"><i class="fa fa-2x fa-map-marker" style="border:1px solid lightgray;border-radius:20px;padding:14px 20px;background-color:white;margin-left:15px;"></i></a>
          </div>
        </div>
        <div class="column">
          <ul class="info-list">
            <li class="info">
              <div class="context">name</div>
              <div class="content" v-html="locations[selectedLocation].company"></div>
            </li>
            <li class="info">
              <div class="context">address</div>
              <div class="content" v-html="locations[selectedLocation].address"></div>
            </li>
            <li class="info">
              <div class="context">phone</div>
              <div class="content" v-html="locations[selectedLocation].phone"></div>
            </li>
            <li class="info">
              <div class="context">email</div>
              <div class="content" v-html="getEmailTags(locations[selectedLocation].email)">
              </div>
            </li>
            <li class="info">
              <div class="context">operation</div>
              <div class="content" v-html="locations[selectedLocation].operation"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="container container-content" v-if="locations && locations[selectedLocation] && locations[selectedLocation].removed && locations.length > 0" style="margin-top:1rem;" data-aos="fade-up" data-aos-once="true">
      <div class="columns">
        <div class="column">
          <div class="content">
            <h1 class="title" style="margin-top:3em;margin-bottom:1em;">We have moved!</h1>
            <span>Please visit us at our <a href="#" @click="onReturnMainShowroom($event)" style="border-bottom: 1px solid black;">Main Showroom</a> for now.</span>
          </div>
        </div>
      </div>
    </div>

    <div class="container container-content" v-if="error" style="margin-top:2em;">
      <h1 class="title">Locate</h1>
      <div class="control notification is-danger" v-if="error">
        <button class="delete" @click="error = undefined"></button>
        {{ error }}
      </div>
    </div>

  </div>
</template>

<script>
  import img01 from '@/assets/lasting_impressions_banner_3.jpg'
  import img01m from '@/assets/lasting_impressions_banner_3_m.jpg'
  import mapIcon from '@/assets/location-icon.png'
  import Slick from 'vue-slick'
  import Lightbox from 'vue-lightbox'

  import auth from '@/apis/Auth'
  import ShowDown from 'showdown'

  export default {
    name: 'locate',
    components: {
      Slick,
      Lightbox
    },
    data () {
      return {
        isDesktop: true,
        slickOptions: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          responsive: [
            {
              breakpoint: 1008,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
              }
            }, {
              // 768 = tablet (not break yet)
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: true
              }
            }, {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: true
              }
            }
          ]
        },
        images: [
          {
            title: 'Showcase 01',
            src: img01,
            srcMobile: img01m,
            desc: '',
            other: ''
          } // ,
          // {
          //   title: 'Showcase 02',
          //   src: img02,
          //   desc: '',
          //   other: ''
          // }
        ],
        items: [],
        error: undefined,
        locations: [],
        // [
        //   {
        //     shortname: 'PJ',
        //     title: 'Sunway Damansara, Petaling Jaya',
        //     company: 'Lasting Impressions Sdn Bhd',
        //     address: 'No. 2, Jalan PJU 3/47,<br />Sunway Damansara Technology Park,<br />Sunway Damansara,<br />47180 Petaling Jaya,<br />Selangor',
        //     description: 'Our Sunway Damansara showroom displays 10000 sq.ft of exquisite furniture, porcelain table lamps, art and accessories on 2 floors.',
        //     phone: '(6) 03 7806 1491',
        //     operation: 'Mon-Sat: 10am to 6.30pm<br />Sun: Closed on Sundays<br /><br />Closed on selected public holidays - please call us to check',
        //     email: 'sales@lasting-impressions.com.my',
        //     position: { lat: 3.165218, lng: 101.600769 },
        //     location: {
        //       zoom: 15,
        //       place: 'Sunway Damansara',
        //       area: 'Petaling Jaya',
        //       link: 'https://www.google.com/maps/place/2,+Jalan+PJU+3%2F47,+Sunway+Damansara,+47810+Petaling+Jaya,+Selangor,+Malaysia/@3.1652183,101.5985804,17z/data=!3m1!4b1!4m5!3m4!1s0x31cc4f3ba40dde09:0xf88c8d160460ae90!8m2!3d3.1652183!4d101.6007691',
        //       direction: 'https://maps.google.com/maps?ll=3.165218,101.600769&z=13&t=m&hl=en-US&gl=MY&mapclient=embed&daddr=2%2C%20Jalan%20PJU%203%2F47%20Sunway%20Damansara%2047810%20Petaling%20Jaya%20Selangor@3.1652183,101.6007691',
        //       location: '2, Jalan PJU 3/47, Sunway Damansara, 47810 Petaling Jaya, Selangor, Malaysia'
        //       // location: '2 Jalan PJU 3/47 Sunway Damansara Petaling Jaya Selangor Malaysia'
        //     }
        //   }, {
        //     shortname: 'Bangsar',
        //     title: 'Bangsar Village 2, Kuala Lumpur',
        //     company: 'Lasting Impressions Sdn Bhd',
        //     address: '2nd Floor, Bangsar Village 2,<br />Jalan Telawi Satu, Bangsar Baru,<br />59100 Kuala Lumpur,<br />Malaysia',
        //     description: 'Lasting Impressions Sdn Bhd Bangsar showroom is located in Bangsar Village 2 which is a boutique shopping centre located a short drive away from the mid to upper class neighbourhoods of Petaling Jaya and Kuala Lumpur.',
        //     phone: '(6) 03 4253 4903',
        //     operation: 'Daily: 10am to 9pm',
        //     email: 'sales@lasting-impressions.com.my',
        //     position: { lat: 3.130703, lng: 101.671364 },
        //     location: {
        //       zoom: 15,
        //       place: 'Bangsar',
        //       area: 'Kuala Lumpur',
        //       link: 'https://maps.google.com/maps?ll=3.1307,101.67136&z=14&t=m&hl=en&gl=US&mapclient=embed&cid=8867500570610347314',
        //       direction: 'https://maps.google.com/maps?ll=3.1307,101.67136&z=14&t=m&hl=en&gl=US&mapclient=embed&daddr=Bangsar%20Village%20II%20Bangsar%20Village%201%2C%20Jalan%20Telawi%203%20Bukit%20Bangsar%2C%2059100%20Kuala%20Lumpur%2C%20Federal%20Territory%20of%20Kuala%20Lumpur%2C%20Malaysia@3.1307,101.67136',
        //       location: 'Bangsar Village, 1, Jalan Telawi 3, Bukit Bangsar, 59100 Kuala Lumpur, Malaysia'
        //     }
        //   }, {
        //     shortname: 'GE Mall',
        //     title: 'Great Eastern Mall, Kuala Lumpur',
        //     company: 'Eastern Charm',
        //     address: '2nd Floor, Great Eastern Mall,<br />303 Jalan Ampang,<br />50450 Kuala Lumpur,<br />Malaysia',
        //     description: 'Lasting Impressions Sdn Bhd Kuala Lumpur showroom is known as Eastern Charm and is located in Great Eastern Mall which is a neighbourhood shopping centre located near the foreign embassy row in the Ampang Hilir area. It is also just a short hop away from KLCC.',
        //     phone: '(6) 03 4253 4903',
        //     operation: 'Daily: 10am to 9pm',
        //     email: 'sales@lasting-impressions.com.my',
        //     position: { lat: 3.160659, lng: 101.736539 },
        //     location: {
        //       zoom: 15,
        //       place: 'Great Eastern Mall',
        //       area: 'Kuala Lumpur',
        //       link: 'https://maps.google.com/maps?ll=3.160073,101.736901&z=14&t=m&hl=en&gl=US&mapclient=embed&cid=1680287583852137792',
        //       direction: 'https://maps.google.com/maps?ll=3.160073,101.736901&z=14&t=m&hl=en&gl=US&mapclient=embed&daddr=Great%20Eastern%20Mall%20303%2C%20Jalan%20Ampang%20Desa%20Pahlawan%2055000%20Kuala%20Lumpur%2C%20Federal%20Territory%20of%20Kuala%20Lumpur%2C%20Malaysia@3.1600725,101.7369013',
        //       location: '303, Jalan Ampang, Desa Pahlawan, 55000 Kuala Lumpur, Federal Territory of Kuala Lumpur, Malaysia'
        //     }
        //   }
        // ],
        mapStyle: [
          {
            'featureType': 'administrative',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#444444'
              }
            ]
          },
          {
            'featureType': 'landscape',
            'elementType': 'all',
            'stylers': [
              {
                'visibility': 'off'
              },
              {
                'color': '#f2f2f2'
              }
            ]
          },
          {
            'featureType': 'poi',
            'elementType': 'all',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          },
          {
            'featureType': 'road',
            'elementType': 'all',
            'stylers': [
              {
                'saturation': -100
              },
              {
                'lightness': 45
              },
              {
                'visibility': 'on'
              }
            ]
          },
          {
            'featureType': 'road.highway',
            'elementType': 'all',
            'stylers': [
              {
                'visibility': 'on'
              }
            ]
          },
          {
            'featureType': 'road.arterial',
            'elementType': 'labels.icon',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          },
          {
            'featureType': 'transit',
            'elementType': 'all',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          },
          {
            'featureType': 'water',
            'elementType': 'all',
            'stylers': [
              {
                'color': '#d6ccbc'
              },
              {
                'visibility': 'on'
              }
            ]
          }
        ],
        selectedLocation: 0,
        selectedPlace: undefined,
        mapIcon: mapIcon
      }
    },
    computed: {
      wazeUrl: function () {
        var location = this.locations[this.selectedLocation]
        return 'https://waze.com/ul?ll=' + location.location.latitude + ',' + location.location.longitude
      },
      googleMapsUrl: function () {
        // var location = this.locations[this.selectedLocation]
        // return 'http://maps.google.com/maps?z=' + location.zoom + '&t=m&q=loc:' + location.position.lat + '+' + location.position.lng
        if (!this.locations[this.selectedLocation] ||
          !this.locations[this.selectedLocation].location) {
          console.error('Invalid selected location')
          return
        }
        return this.locations[this.selectedLocation].location.link
      }
    },
    watch: {
    },
    created () {
      // console.log('created Locate.vue')
    },
    mounted () {
      // console.log('mounted Locate.vue')
      // window.GA('send', 'pageview')

      // on event resize
      this.isDesktop = (window.innerWidth >= 768)
      window.addEventListener('resize', function (event) {
        // console.log('on viewport change')
        this.isDesktop = (event.target.innerWidth >= 768)
      }.bind(this))

      // getting all locations
      var converter = new ShowDown.Converter()
      this.getCompany((data) => {
        // console.log('get all companies')
        // console.log(data)
        var locations = data
        for (var i = 0; i < data.length; i++) {
          var location = locations[i]
          if (location.shortname === 'Bangsar') {
            location.removed = true
          }
          var items = ['address', 'description', 'operation']
          items.forEach(function (item) {
            var content = location[item]
            var html = converter.makeHtml(content)
            // this.paragraph.content = html
            location[item] = html
          })
          location.position = {
            lat: parseFloat(location.location.latitude),
            lng: parseFloat(location.location.longitude)
          }
          location.zoom = parseFloat(location.location.zoom)
        }
        // google map init
        this.locations = locations
        this.selectedLocation = 0
        this.$gmapDefaultResizeBus.$emit('resize')
        console.log(locations)
      }, (error) => {
        console.log(error)
      })

      // google map init
      this.selectedLocation = 0
      this.$gmapDefaultResizeBus.$emit('resize')
    },
    methods: {
      onScrollTo: function (name) {
        this.$scrollTo('#' + name)
      }.bind(this),

      next () {
        this.$refs.slick.next()
      },
      prev () {
        this.$refs.slick.prev()
      },
      reInit () {
        this.$refs.slick.reSlick()
      },
      getEmailTags (email) {
        return ((email && email.length > 0) ? `<a href="mailto:${email}" target="_blank">${email}</a>` : '')
      },
      getCompany (onComplete, onError) {
        auth.company()
        .then(data => {
          if (onComplete) {
            onComplete(data)
          }
        })
        .catch(error => {
          this.error = error.error
          if (onError) {
            onError(error)
          }
        })
      },
      setPlace (place) {
        console.log(place)
        this.selectedPlace = place
        this.position = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        }
      },
      onReturnMainShowroom ($event) {
        $event.preventDefault()
        this.selectedLocation = 0
      }
    }
  }
</script>

<style lang="scss">
@import "../assets/app_setting.scss";
@import "../styles/carousel_slick.scss";

.page-locate {
}

$smallscreen: 480px;

.is-smallscreen {
  display: inherit;
  @media screen and (min-width: $smallscreen) {
    display: none;
  }
}

.is-hidden-smallscreen {
  display: none;
  @media screen and (min-width: $smallscreen) {
    display: inherit;
  }
}

.tabs {
  font-size: 0.9rem;
  letter-spacing: 0.12em;
  ul {
    margin-left: 0;
    margin-right: 0;
  }

  a {
    // border-bottom: 1px solid $color-gold;
  }

  a:hover, li.is-active a {
    border-bottom-color: $color-gold;
  }
}

.container-tabs,
.container-map,
.container-content {
  padding: 15px 15px;
  position: relative;

  @media screen and (min-width: $desktop) {
    padding: 15px 15px 0;
  }
}

.container-content {
  padding-bottom: 50px;
}

.container-apps {
  text-align: center;

  @media screen and (min-width: $desktop) {
    text-align: left;
  }

  div {
  }
}

.map-container {
  background-color: gray;
  margin: 0 auto;
  width: 500px;
  height: 300px;
}

.search {
  margin-bottom: 12px;
}

.gmap,
.pano {
  margin: 0 auto;
  width: 100%;
  height: 400px;
}


.placecard {

  &__container {
    position: absolute;
    left: 10px;

    box-shadow: rgba(0, 0, 0, 0.298039) 0px 1px 4px -1px;
    max-width: 330px;
    width: 100%;
    background: rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box;
    border-radius: 2px 2px 2px 2px;
    font: normal normal normal normal 11px / normal Roboto, Arial, sans-serif;
    margin: 10px;
    padding: 9px 4px 9px 11px;
    overflow: hidden;
  }

  &__left {
    float: left;
    width: 75%;
  }

  &__right {
    text-align: center;
    float: left;
    width: 25%;
  }

  &__business-name {
    cursor: default;
    height: 19px;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px;
    perspective-origin: 100px 9.5px;
    transform-origin: 100px 9.5px;
    font: normal normal 500 normal 14px / normal Roboto, Arial;
    overflow: hidden;
    margin: 0;
  }

  &__info {
    color: rgb(91, 91, 91);
    cursor: default;
    height: 38px;
    width: 200px;
    column-rule-color: rgb(91, 91, 91);
    perspective-origin: 100px 16px;
    transform-origin: 100px 16px;
    border: 0px none rgb(91, 91, 91);
    line-height: 1em;
    font: normal normal normal normal 12px / normal Roboto, Arial;
    margin: 6px 0px 0px;
    outline: rgb(91, 91, 91) none 0px;
  }

  &__direction-icon {
    background: rgba(0, 0, 0, 0) url("https://maps.gstatic.com/mapfiles/embed/images/entity11.png") repeat scroll 95px 0px / 70px 210px padding-box border-box;
    height: 22px;
    width: 22px;
    margin-right: auto;
    margin-left: auto;
  }

  &__direction-link {
    color: $color-gold;
    display: block;
    height: 43px;
    text-decoration: none;
    width: 54.7344px;
  }

  &__view-large {
    display: block;
    margin-top: 20px;
    color: $color-gold;
    text-decoration: none;
  }

}

.info-list {
  .info {
    margin-top: 15px;

    .context {
      border-right: 1px solid #c4c6c6;
      padding-bottom: 12px;
      padding-right: 4%;
      text-align: right;
      width: 25%;
      margin-right: 2.6%;
      display: inline-block;
      vertical-align: top;
    }

    .content {
      width: 70%;
      display: inline-block;
      vertical-align: top;

      &, p {
        color: $color-gray;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// LocateUs.vue?4d6b3772